import { apiCmo } from "./apiCmo"

const usersApi = apiCmo.injectEndpoints({
  endpoints: (builder) => ({
    getProfilesCmo: builder.query({
      query: () => "api/api/perfiles",
    }),
    getPuestosCmo: builder.query({
      query: () => "api/api/puestos",
    }),
    getZonasComercialesCmo: builder.query({
      query: () => "api/api/zonas_comerciales",
    }),
    getClientesCmo: builder.query({
      query: () => "api/api/clientes",
    }),
    getGerentesCmo: builder.query({
      query: () => "api/api/gerentes",
    }),
    registerUsuarioCmo: builder.mutation({
      query: (data) => ({
        url: "api/api/registrar_usuario",
        method: "POST",
        body: data,
      }),
    }),
  }),
})

export const {
  useGetProfilesCmoQuery,
  useGetPuestosCmoQuery,
  useGetZonasComercialesCmoQuery,
  useGetClientesCmoQuery,
  useGetGerentesCmoQuery,
  useRegisterUsuarioCmoMutation,
} = usersApi
